// The reward machines by id (B16), and the one the open trip uses. App sets it from the live pack
// (rewardMachineFor); screens read it with useRewardMachine(). 3D cabinets are in cabinets3d.ts.
import { create } from 'zustand'
import { NEUTRAL_MACHINE, type RewardMachineId } from '../../../shared/rewards'
import { chest } from './chest'
import { claw } from './claw'
import { gashapon } from './gashapon'
import type { MachineWords, RewardMachine } from './types'

export const REWARD_MACHINES: Record<RewardMachineId, RewardMachine> = { gashapon, chest, claw }

export const useMachineId = create<{ id: RewardMachineId }>(() => ({ id: NEUTRAL_MACHINE }))

export function useRewardMachine(): RewardMachine {
  return REWARD_MACHINES[useMachineId((s) => s.id)] ?? REWARD_MACHINES[NEUTRAL_MACHINE]
}

export function useMachineWords(): MachineWords {
  return useRewardMachine().words
}
